/* eslint-disable @typescript-eslint/naming-convention */
import { type TaskTypeOption } from '@app/api/tasks';

export enum SocketMessages {
    taskItemComplete = 'task item complete',
    taskLangComplete = 'task lang complete',
    taskCreated = 'task created',
    taskLanguageAssigneesChanged = 'task language assignees changed',
    taskClosed = 'task closed',
    taskDeleted = 'task deleted',
    bgProcessCountChanged = 'bg process count changed',
    bgProcessUpdated = 'bg process updated',
    bgProcessFinished = 'bg process finished',
}

export type BgProcessFinishedPayload = {
    group_id: string;
    id: string;
    params: {
        project_id: string;
        branch_id: number;
        branch_name?: string;
        key_count?: number;
    };
    info: {
        files?: [];
        project_name?: string;
        keys_unprocessable_count?: number;
    };
    user: {
        id: number;
    };
    type: string;
    status: string;
    progress: string;
};

export type BgProcessUpdatedPayload = {
    group_id: string;
    id: string;
    params: {
        project_id: string;
        branch_id: number;
        branch_name?: string;
    };
    user: {
        id: number;
    };
    type: string;
    status: string;
    progress: string;
    bulk?: {
        keyCount: number;
    };
};

export type LanguageCompletePayload = {
    task_id: number;
    languageName: string;
    completedBy: string;
    isAutoClosingLanguages: boolean;
    isAutomaticallyCompleted: boolean;
};

export type ItemCompletePayload = {
    task_id: number;
    task_item_id: number;
    completed: boolean;
    completedBy: number;
    projectId: string;
    languageProgress: number;
    isAutoClosingLanguages: boolean;
};

export type TaskClosedPayload = {
    task_id: string;
    projectId: string;
    // These props below were added later. Not all socket events send it along.
    taskType?: TaskTypeOption;
    createdBy?: string;
};

export type ActionPayloads = {
    bgProcessUpdated: BgProcessUpdatedPayload;
    bgProcessFinished: BgProcessFinishedPayload;
    taskLangComplete: LanguageCompletePayload;
    taskClosed: TaskClosedPayload;
    taskItemComplete: ItemCompletePayload;
    taskCreated: void;
    taskLanguageAssigneesChanged: void;
    taskDeleted: void;
    bgProcessCountChanged: void;
    translationEditStart: { translationId: number };
};

export type SocketMessagesKeys = keyof typeof SocketMessages;

export type SocketMessage = {
    [Action in keyof ActionPayloads]: { message: Action; payload: ActionPayloads[Action] };
}[keyof ActionPayloads];
